<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} nhóm trao đổi
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tên nhóm trao đổi" prop="$vn_text">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.$vn_text"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="9">
                    <el-form-item label="Tên nhóm bệnh" prop="nhom_benh_ids">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value.nhom_benh_ids
                        "
                        placeholder="Nhập tên nhóm bệnh để tìm kiếm"
                        no-data-text="Chưa có dữ liệu"
                        clearable
                        filterable
                        collapse-tags
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listNhomBenh"
                          :key="item.id"
                          :label="item.ten_nhom.vi"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>{{
                aLang.c_create
              }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="index"
            label="STT"
            align="center"
          ></el-table-column>
          <!-- <el-table-column prop="id" label="Mã nhóm"></el-table-column> -->
          <el-table-column
            prop="name"
            label="Tên nhóm trao đổi"
            :sortable="mData.tableRules.allowSorting"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                style="position: relative, white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
              >
                <span :id="'name-' + scope.row.id">{{ scope.row.name }}</span>
                <!-- <b-tooltip :target="'name-' + scope.row.id">{{
                  scope.row.name
                }}</b-tooltip> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Mã nhóm bệnh" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.icd10_group && scope.row.icd10_group.length>0 && scope.row.icd10_group[0].icd10_group_code ? scope.row.icd10_group[0].icd10_group_code : '' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Tên nhóm bệnh" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.icd10_group && scope.row.icd10_group.length>0 && scope.row.icd10_group[0].icd10_group_code ? getNameDiseases(scope.row.icd10_group[0].icd10_group_code): '' }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="Số thành viên được mời" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.inviting_member_ids.length}}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="Số lượng thành viên"
            align="center"
            :sortable="mData.tableRules.allowSorting"
            prop="config.limit_active_member"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.active_member_ids.length +
                "/" +
                (scope.row.config.limit_active_member
                  ? scope.row.config.limit_active_member
                  : 0)
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Số lượng nhóm bệnh" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.nhom_benh_ids.length}}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="created_time"
            label="Thời gian tạo"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>
          <el-table-column width="200" align="center" label="Thao tác">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-view"
                @click="fn_handle('detail', scope, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              ></el-button>
              <el-button
                icon="el-icon-edit"
                @click="fn_handle('update', scope, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              ></el-button>
              <el-button
                icon="el-icon-delete"
                @click="fn_handle('delete', scope, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ChatRoomModel from "./ChatRoomModel";
import ChatRoomApi from "../../../moduleApi/ChatRoomApi";
import NhomBenhApi from "../../../moduleApi/NhomBenhApi";
import * as moment from "moment";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "ChatRoom", //requied
        tableRules: MethodService.copyObject(ChatRoomModel.tableRules),
        dataDefault: {
          textFindNhomBenh: "",
          listNhomBenh: [],
          listNhomBenhSelected: [],
        },
      },
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      // if (this.mData.tableRules.dataSearch.value.nhom_benh_ids) {
      //   let resNhomBenh = await NhomBenhApi.list({
      //     limit: 1000,
      //     filters: `id:in:${this.mData.tableRules.dataSearch.value.nhom_benh_ids.split(
      //       ","
      //     )}`
      //   });
      //   this.mData.dataDefault.listNhomBenh = resNhomBenh.result;
      // } else {
      //   this.mData.dataDefault.listNhomBenh = [];
      // }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        });
      }

      let res = await ChatRoomApi.list(dataFilter);

      let data = [];
      res.result.forEach((item) => {
        let cache = MethodService.copyObject(ChatRoomModel.dataForm);
        for (let key of Object.keys(item)) {
          cache[key] = item[key];
        }
        data.push(cache);
      });
      this.mData.tableRules.data = data;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await ChatRoomApi.delete(id);
      this.fn_initTable();
    },

    //event table
    getNameDiseases(val) {
      let name = '';
      if (this.mData.dataDefault.listNhomBenh) {
        console.log("this.mData.dataDefault.listNhomBenh", this.mData.dataDefault.listNhomBenh);
        const diseases = this.mData.dataDefault.listNhomBenh.find(
          (item) => item.ma_nhom == val
        );
        if (diseases) {
          name = diseases.ten_nhom.vi;
        }
      }
      return name;
    },
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (this.mData.tableRules.dataSearch.value.name) {
            this.mData.tableRules.dataSearch.value.name =
              this.mData.tableRules.dataSearch.value.name.trim();
          }
          // if (this.mData.dataDefault.listNhomBenhSelected.length > 0) {
          //   this.mData.tableRules.dataSearch.value.nhom_benh_ids = this.mData.dataDefault.listNhomBenhSelected.join(
          //     ","
          //   );
          // } else {
          //   this.mData.tableRules.dataSearch.value.nhom_benh_ids = null;
          // }
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        if (this.mData.tableRules.dataSearch.value.nhom_benh_ids) {
          this.mData.dataDefault.listNhomBenhSelected =
            this.mData.tableRules.dataSearch.value.nhom_benh_ids.split(",");
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },

    async fn_initData() {
      try {
        let resNhomBenhApi = await NhomBenhApi.list({
          limit: 10000,
        });

        if (resNhomBenhApi.result && resNhomBenhApi.result.length) {
          this.mData.dataDefault.listNhomBenh = resNhomBenhApi.result;
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    async fn_remoteGetListNhomBenh(query) {
      this.mData.dataDefault.textFindNhomBenh = query;
      this.mData.dataDefault.listNhomBenh = [];
    },
    async fn_enterFindNhomBenh() {
      if (this.mData.dataDefault.textFindNhomBenh) {
        let resNhomBenhApi = await NhomBenhApi.list({
          limit: 1000,
          filters: `ten_nhom.en:regex_i:${this.mData.dataDefault.textFindNhomBenh}|ten_nhom.vi:regex_i:${this.mData.dataDefault.textFindNhomBenh}`,
        });

        if (resNhomBenhApi.result && resNhomBenhApi.result.length) {
          this.mData.dataDefault.listNhomBenh = resNhomBenhApi.result;
        }
      }
    },
  },

  //run after render view
  created() {
    this.fn_hashUrl();
    this.fn_initData();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>
